var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"LySlider"},[_c('div',{staticClass:"lyInner"},[_c('div',{staticClass:"lyItem LyMe"},[_c('img',{attrs:{"src":_vm.url,"alt":"image"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }